import React from 'react'
import PropTypes from 'prop-types'
import SearchResults from './SearchResults'
import { useHelpContext } from '../hooks'
import { useEducationAnalytics } from 'education-tools'

Search.propTypes = {
  children: PropTypes.node
}

export default function Search({ children }) {
  const {
    navigation: {
      activePage: { searchQuery }
    }
  } = useHelpContext()

  useEducationAnalytics({
    category: 'uhqm/search',
    action: 'query',
    label: searchQuery,
    skip: searchQuery === '',
    debounce: 1000,
    trackOnMount: true
  })

  return (
    <>
      {searchQuery && <SearchResults />}
      <div style={{ display: searchQuery ? 'none' : 'block' }}>{children}</div>
    </>
  )
}
